import React from 'react';
import { Box, Chip, Tooltip, Typography } from '@mui/material';

export function SuggestionsGrid({ suggestionsToShow, itemsPerRow, totalCount, currentPage, onChooseSuggestion }) {
    const totalRows = Math.ceil(suggestionsToShow.length / itemsPerRow);

    return (
        <Box
            display='flex'
            flexDirection='column'
            alignItems={totalCount === undefined ? 'end' : 'center'}
            marginRight={totalCount === undefined ? 2 : 0}
            overflow={totalCount === undefined ? 'visible' : 'hidden'}
            width={totalCount === undefined ? 'unset' : '100%'}
            gap={1}
        >
            {Array.from({ length: totalRows }).map((_, rowIndex) => (
                <Box
                    key={`row-${rowIndex}`}
                    display='flex'
                    flexDirection='row'
                    gap={2}
                    justifyContent={totalCount === undefined ? 'end' : 'center'}
                    overflow='auto'
                    flexWrap='wrap'
                    width='100%'
                >
                    {suggestionsToShow
                        .slice(rowIndex * itemsPerRow, (rowIndex + 1) * itemsPerRow)
                        .map((suggestion, index) => {
                            const chipKey = `${rowIndex}-${index}-${String(suggestion)}`;
                            return (
                                <Tooltip title={suggestion} key={chipKey}>
                                    <Chip
                                        label={suggestion}
                                        onClick={() => onChooseSuggestion(suggestion)}
                                        clickable
                                        variant='outlined'
                                        sx={{
                                            overflow: 'hidden',
                                            minWidth: '100px',
                                            maxWidth: '300px',
                                            justifyContent: 'flex-start',
                                            backgroundColor: 'rgba(255,255,255,0.86)',
                                            color: 'rgba(15, 23, 42, 0.84)',
                                            borderColor: 'rgba(148, 163, 184, 0.42)',
                                            backdropFilter: 'blur(8px)',
                                            boxShadow: '0 10px 22px rgba(15, 23, 42, 0.06)',
                                            '& .MuiChip-label': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                                display: 'block',
                                                width: '100%',
                                                fontWeight: 500,
                                            },
                                            '&:hover': {
                                                backgroundColor: 'rgba(255,255,255,0.96)',
                                                borderColor: 'rgba(100, 116, 139, 0.48)',
                                            },
                                        }}
                                    />
                                </Tooltip>
                            );
                        })}
                </Box>
            ))}
            {totalCount && totalCount > itemsPerRow && (
                <Box
                    sx={{
                        mt: 1,
                        px: 1.25,
                        py: 0.35,
                        borderRadius: 99,
                        backgroundColor: 'rgba(255,255,255,0.78)',
                        border: '1px solid rgba(148, 163, 184, 0.28)',
                        backdropFilter: 'blur(8px)',
                    }}
                >
                    <Typography
                        variant='caption'
                        align='center'
                        sx={{
                            color: 'rgba(15, 23, 42, 0.7)',
                            fontWeight: 600,
                        }}
                    >
                        {`${itemsPerRow * currentPage + suggestionsToShow.length} / ${totalCount}`}
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
